/**
 * Design System: Breakpoints
 * Mobile: < 640px | Tablet: 640-1024px | Desktop: >= 1024px
 */
import React from "react"

export const bp = {
  mobile: 640,
  tablet: 1024,
  desktop: 1024,
}

export const breakpoints = bp

export function useBreakpoint() {
  const [width, setWidth] = React.useState(
    typeof window !== "undefined" ? window.innerWidth : 1280
  )
  React.useEffect(() => {
    const handler = () => setWidth(window.innerWidth)
    window.addEventListener("resize", handler)
    return () => window.removeEventListener("resize", handler)
  }, [])
  return {
    isMobile: width < bp.mobile,
    isTablet: width >= bp.mobile && width < bp.tablet,
    isDesktop: width >= bp.tablet,
    width,
  }
}
